import gql from 'graphql-tag';

export const GET_SCHOOLS = gql`
  query GetSchools($query: SchoolQuery!) {
    getSchoolsWithUsers(query: $query) {
      _id
      name
      region {
        _id
        name
      }
      totalStudents
      type
    }
  }
`;
export const GET_SCHOOLS_PROPOSALS = gql`
  query GetSchoolProposals($queries: SchoolProposalsQuery!) {
    getSchoolProposals(queries: $queries) {
      _id
      name
      region {
        _id
        name
      }
      totalStudents
      type
    }
  }
`;

export const GET_SCHOOLS_STATISTICS = gql`
  query SchoolStatistics {
    getSchoolsStats {
      totalPending
      totalPrivate
      totalPublic
      totalSchools
    }
  }
`;

export const GET_SCHOOLS_SIMPLE = gql`
  query GetSchools($query: SchoolQuery!) {
    getSchools(query: $query) {
      _id
      name
      totalStudents
      type
    }
  }
`;
